import React from "react";
import { getTodayTimeStr, getTodayTime, isAllowedDate } from "../util/";

export default function TodayButton({
  prefixCls,
  locale,
  value,
  timePicker,
  disabledDate,
  disabledTime,
  onToday,
  text,
  ecId
}) {
  let disabledToday = false;
  let localeNow = text;
  if (!localeNow && timePicker) {
    localeNow = locale.now;
  }
  localeNow = localeNow || locale.today;
  let disabledTodayClass = "";
  if (disabledDate) {
    disabledToday = !isAllowedDate(
      getTodayTime(value),
      disabledDate,
      disabledTime
    );
    if (disabledToday) {
      disabledTodayClass = `${prefixCls}-today-btn-disabled`;
    }
  }
  return (
    <a
      ecId={`${ecId}_a@owz8gi`}
      className={`${prefixCls}-today-btn ${disabledTodayClass}`}
      role="button"
      onClick={disabledToday ? null : onToday}
      title={getTodayTimeStr(value)}
    >
      {localeNow}
    </a>
  );
}



// WEBPACK FOOTER //
// ./_rc-calendar-5.6.2/src/calendar/TodayButton.jsx